module.exports = __webpack_public_path__ + "img/bg-noData-1.639cfe03.png";